import React from 'react';
import { StylePropType } from '../../components';
import './moreSendAare.less';
// import autobind from 'autobind-decorator';
// import { push } from '../../utils';
import PropTypes from 'prop-types';

interface MoreSendAarePropType extends StylePropType {
    prefixCls?: string;
    areName?: any;
    onClick?: any;
    toClickArea?:any;
    areaSend?:any;
}

class MoreSendAare extends React.Component<MoreSendAarePropType, any> {
    static defaultProps = {
        prefixCls: 'moreSendAare'
    };

    constructor(props, context) {
        super(props, context);
    }

  

    render() {
        const { prefixCls, areName ,toClickArea,areaSend} = this.props;
        return (
            <div className={`${prefixCls}`} onClick={toClickArea}>
                <div className ={`${prefixCls}-left`} >送至</div>
                <div className = {`${prefixCls}-right`}>{areName!='' ?areName:'请选择配送地址'}</div>  
                <div className={`${prefixCls}-more_selecte_icon`}></div>
                {areaSend &&<div className = { `${prefixCls}-no-words`}>暂不配送</div>}
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default MoreSendAare;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/moreSendAare/moreSendAare.tsx